export const BookmarkStyle = {
  height: 20,
  paddingTop: 8,
};

export const FilterAll = "all";
